






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  Chart,
  PieController,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

Chart.register(PieController, ArcElement, Tooltip, Legend);

const DEFAULT_COLORS = [
  '#42a5f5',
  '#ef5350',
  '#344767',
  '#9e9e9e',
  '#f57c00',
  '#66bb6a',
  '#ab47bc',
  '#26c6da',
  '#8d6e63',
  '#78909c',
  '#ffa726',
  '#7e57c2',
];

@Component({})
export default class PieChartComponent extends Vue {
  @Prop({ required: true }) labels!: string[];
  @Prop({ required: true }) values!: number[];
  @Prop({ default: 'Antriebe' }) datasetLabel!: string;
  @Prop({ default: () => DEFAULT_COLORS }) colors!: string[];
  @Prop({ default: 1.4 }) aspectRatio!: number;
  @Prop({ default: '100%' }) radius!: string | number;

  private chart: Chart | null = null;

  mounted() {
    this.renderChart();
  }

  beforeDestroy() {
    this.chart?.destroy();
  }

  @Watch('labels')
  @Watch('values')
  @Watch('colors')
  @Watch('aspectRatio')
  @Watch('radius')
  onDataChange() {
    this.chart?.destroy();
    this.renderChart();
  }

  private renderChart() {
    const canvas = this.$refs.canvas as HTMLCanvasElement;
    if (!canvas || !this.labels.length) return;

    const backgroundColor = this.labels.map((_, index) => this.colors[index % this.colors.length]);
    const values = this.values;
    const total = values.reduce((sum, value) => sum + value, 0);

    this.chart = new Chart(canvas, {
      type: 'pie',
      data: {
        labels: this.labels,
        datasets: [{
          label: this.datasetLabel,
          data: this.values,
          backgroundColor,
          borderWidth: 0,
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: this.aspectRatio,
        radius: this.radius,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            labels: {
              boxWidth: 10,
              boxHeight: 10,
              padding: 10,
              font: { size: 11 },
              generateLabels: () => this.labels.map((label, index) => {
                const value = Number(values[index] || 0);
                const percent = total ? Math.round((value / total) * 100) : 0;
                const color = backgroundColor[index];
                return {
                  text: `${label} ${value} (${percent}%)`,
                  fillStyle: color,
                  strokeStyle: color,
                  hidden: false,
                  index,
                  datasetIndex: 0,
                };
              }),
            },
          },
          tooltip: {
            callbacks: {
              label: (item) => {
                const value = Number(item.raw || 0);
                const percent = total ? Math.round((value / total) * 100) : 0;
                return ` ${value} Antriebe (${percent}%)`;
              },
            },
          },
        },
      },
    });
  }
}
